import { render, staticRenderFns } from "./SemesterCard.vue?vue&type=template&id=cb91bf12&"
import script from "./SemesterCard.vue?vue&type=script&lang=js&"
export * from "./SemesterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports